import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';
import { toArray } from '@/scenarios/legacy-player/lib/utils/array';

import { PlayerConfigProps, Source } from '../types/config';

export const useSetSource = ({ source, getSource, autostart = true }: PlayerConfigProps) => {
    const sources = source ? toArray(source) : [];
    const sourceId = getSourceId(sources);

    useInstanceEffect(
        (instance) => {
            if (source) {
                const currentSource = instance.source;

                if (
                    currentSource?.id === sourceId ||
                    (!currentSource && instance.type !== 'filmoscope')
                ) {
                    return undefined;
                }

                instance.setSource(source);
            } else if (getSource && instance.type === 'filmoscope') {
                instance.setGetSource(getSource);
            }

            return undefined;
        },
        [sourceId, getSource]
    );

    useInstanceEffect(
        (instance) => {
            if (instance.type === 'filmoscope') {
                return instance.onReady(
                    () => autostart && !instance.isWaitingUserPlay && instance.play()
                );
            }
            return undefined;
        },
        [sourceId, getSource, autostart]
    );
};

function getSourceId(sources: Source[]) {
    return sources.map((source) => source.id).join('_');
}
